import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SelectorFiltradoFactory, SelectorFiltroProps } from "app/features/selectores/logic";

const SugerenciaSegmentoItem = (props: { value: models.SugerenciaSegmento }) =>
    <div>
        {props.value.NombreSegmento}
        <br />
        <span className={"label label-" + (
            props.value.Tipo == models.TipoSugerenciaSegmento.Ninguna ? "danger" :
                props.value.Tipo == models.TipoSugerenciaSegmento.EnRutaEnSucursal ? "success" :
                    "warning"
        )} >
            {models.TipoSugerenciaSegmento[props.value.Tipo]}
        </span>
    </div>;

export interface Filtro {
    /**Indefinido para tomar la sucursal del usuario actual */
    idSucursalOrigen?: number;
    idCamion?: number;
}

/**Selector de un IdSegmento, mostrando primero los segmentos sugeridos para el siguiente viaje del camion establecido
 */
export const SugerenciaSegmento  = SelectorFiltradoFactory<models.SugerenciaSegmento, Filtro>(
    (filtro) => filtro ? observeResource(resources.ViajeRuta.ObtenerSugerenciasSegmento, filtro.idCamion, filtro.idSucursalOrigen) : [],
    x => x.IdSegmento,
    x => ({
        label: x.NombreSegmento,
        view: <SugerenciaSegmentoItem value={x} />
    }));



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajes/edit/items/selectores/sugerenciasegmento.tsx